import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';

function Ertigacabhireinpune() {



  const cardData =
  {
    keyword: 'Ertiga Cab Hire in Pune',
    heading: 'Sanavi Travels: Ertiga Cab Hire in Pune',
    headingDescription: 'Sanavi Travels offers Ertiga Cab Hire in Pune, providing safe, comfortable, and affordable taxi services for families, corporate travelers, airport transfers, local travel, and outstation trips. Our fleet of well-maintained Maruti Ertiga cabs ensures spacious seating, air-conditioned comfort, and ample luggage space for a smooth and hassle-free journey. With professional chauffeurs, flexible one-way and round-trip cab packages, transparent pricing, and 24/7 booking support, Ertiga cab hire in Pune is ideal for city rides, weekend getaways, and long-distance travel. Choose Sanavi Travels for reliable Ertiga taxi services in Pune, delivering comfort, safety, and punctual service every time.',

    top: 'Top Places to Visit in Pune Outstation  with Sanavi Travels',


"topPlaces": [
  {
    "title": "Lonavala",
    "description": "Lonavala is a popular hill station near Pune, known for its lush green hills, waterfalls, and pleasant climate. Key attractions include Bhushi Dam, Tiger’s Leap, Rajmachi Fort, and Karla Caves. The hill station is ideal for trekking, nature walks, and weekend getaways from Pune."
  },
  {
    "title": "Mahabaleshwar",
    "description": "Mahabaleshwar is a scenic hill station in the Western Ghats, famous for viewpoints like Arthur’s Seat, Elephant’s Head Point, and Bombay Point. Venna Lake, Mapro Garden, and Pratapgad Fort are major attractions. It is popular for strawberry farms, trekking, and panoramic valley views."
  },
  {
    "title": "Bhimashankar",
    "description": "Bhimashankar is a serene destination near Pune, famous for the Bhimashankar Jyotirlinga Temple and the Bhimashankar Wildlife Sanctuary. Visitors can enjoy trekking, Kushalgarh Waterfall, and exploring the Western Ghats’ rich flora and fauna. It is a perfect blend of spirituality and nature."
  },
  {
    "title": "Panchgani",
    "description": "Panchgani is a charming hill station known for Table Land, the second-longest mountain plateau in Asia. Popular attractions include Sydney Point, Parsi Point, and Lingmala Waterfall. The town is famous for its strawberry farms, scenic viewpoints, and peaceful environment, making it ideal for weekend trips."
  },
  {
    "title": "Lavasa",
    "description": "Lavasa is a planned hill city near Pune, known for its picturesque lakes, walking trails, and modern architecture. It offers boating, water sports, and leisure activities amidst scenic surroundings. Lavasa is popular for short getaways and family trips from Pune."
  },
  {
    "title": "Khandala",
    "description": "Khandala, adjacent to Lonavala, is a serene hill station with scenic viewpoints, lush valleys, and waterfalls. Popular spots include Duke’s Nose, Rajmachi Fort, and Tiger’s Leap. It is ideal for trekking, nature photography, and monsoon trips from Pune."
  },
  {
    "title": "Matheran",
    "description": "Matheran is a unique hill station with a vehicle-free environment, offering tranquility and natural beauty. Key attractions include Panorama Point, Louisa Point, Echo Point, and Charlotte Lake. Trekking, toy train rides, and serene viewpoints make it a perfect outstation escape."
  },
  {
    "title": "Alibaug",
    "description": "Alibaug is a coastal town near Pune, known for its beaches, forts, and water sports. Popular spots include Alibaug Beach, Kolaba Fort, and Kihim Beach. Alibaug is ideal for relaxing seaside getaways, weekend trips, and adventure activities from Pune."
  },
  {
    "title": "Nashik",
    "description": "Nashik is a historic city near Pune, famous for vineyards, temples, and the Godavari River. Key attractions include Trimbakeshwar Temple, Sula Vineyards, Pandavleni Caves, and Ramkund. It is popular for wine tours, spiritual visits, and heritage exploration."
  },
  {
    "title": "Igatpuri",
    "description": "Igatpuri is a serene hill station near Pune, known for its scenic landscapes, waterfalls, and Vipassana meditation center. Attractions include Bhatsa River Valley, Camel Valley, and Tringalwadi Fort. It is ideal for trekking, meditation retreats, and monsoon trips from Pune."
  }
]
,




"services": [
  {
    "name": "Ertiga Cab Hire in Pune",
    "description": "Reliable Ertiga cab hire service in Pune for daily commutes, outstation travel, and family trips, ensuring comfort and safety."
  },
  {
    "name": "Ertiga Cab Rental Pune",
    "description": "Flexible rental options for Ertiga cabs in Pune, perfect for short or long trips with convenient booking and transparent pricing."
  },
  {
    "name": "AC Ertiga Cab Pune",
    "description": "Air-conditioned Ertiga cabs providing a cool and comfortable ride, ideal for city travel or long-distance journeys."
  },
  {
    "name": "Luxury Ertiga Cab Pune",
    "description": "Premium Ertiga cabs equipped with extra amenities for a luxurious travel experience in Pune and beyond."
  },
  {
    "name": "Outstation Ertiga Cab Pune",
    "description": "Outstation Ertiga cab service for trips outside Pune, offering spacious seating, luggage space, and reliable drivers."
  },
  {
    "name": "Family Ertiga Cab Pune",
    "description": "Family-friendly Ertiga cab rentals with ample space and comfort for smooth and safe journeys."
  },
  {
    "name": "Corporate Ertiga Cab Pune",
    "description": "Professional Ertiga cab services for corporate travel, ensuring punctuality, convenience, and comfort for employees."
  },
  {
    "name": "Affordable Ertiga Cab Pune",
    "description": "Budget-friendly Ertiga cab options in Pune that provide reliable service without compromising on comfort."
  },
  {
    "name": "Chauffeur Driven Ertiga Cab",
    "description": "Experienced drivers handle your trip, offering a stress-free and safe travel experience in Pune or outstation."
  },
  {
    "name": "Best Ertiga Cab Service Pune",
    "description": "Top-rated Ertiga cab services in Pune, combining comfort, safety, and timely pickups for a premium travel experience."
  },
  {
    "name": "Pune Ertiga Taxi",
    "description": "Convenient Ertiga taxi service in Pune for local or long-distance travel, suitable for individuals, families, and groups."
  },
  {
    "name": "Airport Ertiga Cab Pune",
    "description": "Timely and comfortable Ertiga cab service for airport pickups and drop-offs, ensuring smooth travel to and from Pune airports."
  },
  {
    "name": "Tourist Ertiga Cab Pune",
    "description": "Ertiga cabs designed for sightseeing and tourist trips, offering comfort, reliability, and flexible travel options."
  },
  {
    "name": "Wedding Ertiga Cab Pune",
    "description": "Special Ertiga cab services for wedding travel, accommodating family and guests with comfortable rides and punctual service."
  },
  {
    "name": "Online Cab Booking Pune",
    "description": "Book your Ertiga cab online in Pune with instant confirmation, secure payments, and hassle-free service."
  }
],
"tableData": [
  ["Ertiga Cab Hire in Pune", "Ertiga Cab Rental Pune"],
  ["AC Ertiga Cab Pune", "Luxury Ertiga Cab Pune"],
  ["Outstation Ertiga Cab Pune", "Family Ertiga Cab Pune"],
  ["Corporate Ertiga Cab Pune", "Affordable Ertiga Cab Pune"],
  ["Chauffeur Driven Ertiga Cab", "Best Ertiga Cab Service Pune"],
  ["Pune Ertiga Taxi", "Airport Ertiga Cab Pune"],
  ["Tourist Ertiga Cab Pune", "Wedding Ertiga Cab Pune"],
  ["Online Cab Booking Pune", "—"]
]
,


"whychoose": [
  {
    "WhyChooseheading": "Ertiga Cab Hire in Pune with Sanavi Travels",
    "WhyChoosedescription": "Sanavi Travels offers comfortable and affordable Ertiga cab hire services in Pune, perfect for family trips, airport transfers, city tours, and outstation travel."
  },
  {
    "WhyChooseheading": "Clean and Well-Maintained Vehicles",
    "WhyChoosedescription": "Our Ertiga cabs are regularly serviced, air-conditioned, and kept clean to ensure a smooth and enjoyable ride throughout Pune and beyond."
  },
  {
    "WhyChooseheading": "Experienced and Professional Drivers",
    "WhyChoosedescription": "Our licensed and courteous drivers are familiar with Pune’s roads, ensuring safe, punctual, and stress-free travel for your journey."
  },
  {
    "WhyChooseheading": "Transparent Pricing with No Hidden Charges",
    "WhyChoosedescription": "Sanavi Travels provides upfront and clear pricing for Ertiga cab hire in Pune, including fuel and toll charges, with no hidden fees."
  },
  {
    "WhyChooseheading": "24/7 Customer Support",
    "WhyChoosedescription": "Our customer support team is available round the clock to assist with bookings, trip planning, and any travel queries you may have."
  },
  {
    "WhyChooseheading": "Flexible Ride Options",
    "WhyChoosedescription": "Choose from local rides, airport transfers, hourly hires, and outstation travel packages based on your needs and schedule."
  },
  {
    "WhyChooseheading": "Safe and Sanitized Cabs",
    "WhyChoosedescription": "All vehicles are thoroughly cleaned and sanitized before every trip to ensure a safe and hygienic travel experience."
  },
  {
    "WhyChooseheading": "Reliable and On-Time Service",
    "WhyChoosedescription": "We guarantee punctual pickups and dependable service, making Sanavi Travels a trusted choice for Ertiga cab hire in Pune."
  }
]

}

const faqData = [
  {
    question: 'Does Sanavi Travels offer Ertiga cab hire services in Pune?',
    answer: 'Yes, Sanavi Travels provides comfortable and reliable Ertiga cab hire services in Pune for local and outstation travel.'
  },
  {
    question: 'How can I book an Ertiga cab in Pune?',
    answer: 'You can book an Ertiga cab through our website or by contacting our 24x7 customer support team.'
  },
  {
    question: 'What types of trips can I use the Ertiga cab for?',
    answer: 'You can use the Ertiga cab for local rides, airport transfers, city tours, hourly hires, and outstation journeys.'
  },
  {
    question: 'Are the drivers experienced with Pune routes?',
    answer: 'Yes, our drivers are licensed, professional, and familiar with Pune’s roads to provide a safe and timely journey.'
  },
  {
    question: 'Can I choose custom pickup and drop-off locations?',
    answer: 'Absolutely! You can select your preferred pickup and drop-off locations anywhere in Pune or nearby areas.'
  },
  {
    question: 'Is the Ertiga cab service available 24x7?',
    answer: 'Yes, Sanavi Travels offers round-the-clock cab services to fit your travel schedule.'
  },
  {
    question: 'Are the cabs sanitized before every trip?',
    answer: 'Yes, all Ertiga cabs are thoroughly cleaned and sanitized to ensure a safe and hygienic travel experience.'
  },
  {
    question: 'What payment methods are accepted?',
    answer: 'We accept UPI, credit/debit cards, digital wallets, bank transfers, and corporate payments for your cab bookings.'
  },
  {
    question: 'Is customer support available during the trip?',
    answer: 'Yes, our 24x7 customer support team is available throughout your Ertiga cab journey in Pune.'
  }
];

const testimonials = [
  {
    id: 1,
    name: 'Mr. Sameer Kulkarni',
    feedback: 'Booked an Ertiga cab in Pune with Sanavi Travels — very comfortable ride, polite driver, and excellent service!',
    rating: 5
  },
  {
    id: 2,
    name: 'Ms. Priya Patil',
    feedback: 'Great experience with Ertiga cab hire in Pune. Punctual pickup and smooth journey. Highly recommended!',
    rating: 5
  }
];

















































































  const Images = [
    { place: "/images/keyword/1.jpg", text: "Tempo Traveller On Rent in Pune", link: "tempo-traveller-on-rent-in-pune" },
    { place: "/images/keyword/2.jpg", text: "Pune to Shirdi Tempo Traveller On Rent", link: "pune-to-shirdi-tempo-traveller-on-rent" },
    { place: "/images/keyword/3.jpg", text: "Pune to Mahabaleshwar Tempo Traveller on Rent", link: "pune-to-mahabaleshwar-tempo-traveller-on-rent" },
    { place: "/images/keyword/4.jpg", text: "Pune to Goa Tempo Traveller Hire", link: "pune-to-goa-tempo-traveller-hire" },
    { place: "/images/keyword/5.jpg", text: "Pune to Mumbai Tempo Traveller on Rent", link: "pune-to-mumbai-tempo-traveller-on-rent" },
    { place: "/images/keyword/6.jpg", text: "Pune to Konkan Darshan Tempo Traveller Hire", link: "pune-to-konkan-darshan-tempo-traveller-hire" },
    { place: "/images/keyword/7.jpg", text: "Pune to Nashik Tempo Traveller On Rent", link: "pune-to-nashik-tempo-traveller-on-rent" },
    { place: "/images/keyword/8.jpg", text: "Tempo Traveller On Rent for Pune Darshan", link: "tempo-traveller-on-rent-for-pune-darshan" },
    { place: "/images/keyword/9.jpg", text: "Mini Bus On Rent in Pune", link: "mini-bus-on-rent-in-pune" },
    { place: "/images/keyword/10.jpg", text: "13 Seater Tempo Traveller On Rent in Pune", link: "13-seater-tempo-traveller-on-rent-in-pune" },
    { place: "/images/keyword/11.jpg", text: "17 Seater Tempo Traveller on Rent in Pune", link: "17-seater-tempo-traveller-on-rent-in-pune" },
    { place: "/images/keyword/12.jpg", text: "20 Seater Luxury Bus On Rent Pune", link: "20-seater-luxury-bus-on-rent-pune" },
    { place: "/images/keyword/13.jpg", text: "26 Seater Tempo Traveller On Rent in Pune", link: "26-seater-tempo-traveller-on-rent-in-pune" },
    { place: "/images/keyword/14.jpg", text: "32 Seater Luxury Bus On Rent in Pune", link: "32-seater-luxury-bus-on-rent-in-pune" },
    { place: "/images/keyword/15.jpg", text: "35 Seater Bus on Rent in Pune", link: "35-seater-bus-on-rent-in-pune" },
    { place: "/images/keyword/16.jpg", text: "45 Seater Bus On Rent in Pune", link: "45-seater-bus-on-rent-in-pune" },
    { place: "/images/keyword/17.jpg", text: "50 Seater Bus On Rent in Pune", link: "50-seater-bus-on-rent-in-pune" },
    { place: "/images/keyword/18.jpg", text: "Bus Hire for School Trips in Pune", link: "bus-hire-for-school-trips-in-pune" },
    { place: "/images/keyword/19.jpg", text: "Bus booking for Wedding in Pune", link: "bus-booking-for-wedding-in-pune" },
    { place: "/images/keyword/20.jpg", text: "Bus Booking for Marriage in Pune", link: "bus-booking-for-marriage-in-pune" },
    { place: "/images/keyword/21.jpg", text: "Bus Service for Corporate in Pune", link: "bus-service-for-corporate-in-pune" },
    { place: "/images/keyword/22.jpg", text: "Bus on Rent For Event in Pune", link: "bus-on-rent-for-event-in-pune" },
    { place: "/images/keyword/23.jpg", text: "Bus Hire for Outstation in Pune", link: "bus-hire-for-outstation-in-pune" },
    { place: "/images/keyword/24.jpg", text: "AC Bus On Rent in Pune", link: "ac-bus-on-rent-in-pune" },
    { place: "/images/keyword/25.jpg", text: "Pune Bus Hire Rental Service", link: "pune-bus-hire-rental-service" },
  ];










const jsonData = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Ertiga Cab Hire in Pune - Sanavi Travels",
  "description": "Book Ertiga cabs in Pune with Sanavi Travels. AC and luxury Ertiga cabs for family trips, corporate travel, airport transfers, weddings, outstation journeys, tourist travel, and comfortable chauffeur-driven service.",
  "aggregateRating": {
    "@type": "AggregateRating",
    "bestRating": "5",
    "worstRating": "1",
    "ratingValue": "4.9",
    "ratingCount": "1600"
  }
};




  return (
    <div>


<Helmet>
  <title>
    Ertiga Cab Hire in Pune | Sanavi Travels
  </title>

  <meta
    name="description"
    content="Hire AC and luxury Ertiga cabs in Pune with Sanavi Travels. Perfect for family trips, corporate travel, airport transfers, weddings, outstation journeys, tourist travel, and chauffeur-driven comfort."
  />

  <script type="application/ld+json">
    {JSON.stringify(jsonData)}
  </script>
</Helmet>

      <div className="page-headder bg-section parallaxie">
        <div className="container">
          <div className="row">
            <div className="col-lg-12">
              <div className="page-header-box text-white">
                <h1 className="text-anime-style-3 text-center text-white" data-cursor="-opaque">
                  <h3> {cardData.keyword}</h3>
                </h1>
              </div>
            </div>
          </div>
        </div>
      </div>





      <section>
        <div className="container-fluid" >
          <div className="row container-fluid p-0">
            <div className="col-12 col-md-7 bg-foootr">
              <img src='/images/keyword/56.jpg' alt='img' className='img-fluid' />
              <h3 className="py-1"
                style={{
                  color: '#183765', // Red color for the title 
                  textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                  fontWeight: 'bold'
                }}


              >{cardData.heading} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
              <div className="topPlaces">
                <p className="sectionLead">{cardData.top}</p>

                {cardData.topPlaces.map((place, index) => (
                  <article key={index} className="placeCard" tabIndex="0">
                    <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                    <div className="placeBody">
                      <h4 className="placeTitle">{place.title}</h4>
                      <p className="placeDesc">{place.description}</p>
                    </div>

                    <span className="placeArrow" aria-hidden>›</span>
                  </article>
                ))}
              </div>



              <div className="shambhu-services">
                {cardData.services.map((service, index) => (
                  <div key={index} className="sh-service-card">

                    <div className="sh-service-left">
                      <div className="sh-service-icon">
                        🚖
                      </div>
                    </div>

                    <div className="sh-service-content">
                      <h4 className="sh-service-title">{service.name}</h4>
                      <p className="sh-service-desc">{service.description}</p>
                    </div>

                  </div>
                ))}
              </div>


              <table className="table table-responsive Border-key my-2">
                <tbody className=' Border-key'>
                  {cardData.tableData.map((row, rowIndex) => (
                    <tr className='Border-key ' key={rowIndex}>
                      {row.map((cell, cellIndex) => (
                        <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                      ))}
                    </tr>
                  ))}
                </tbody>
              </table>
              <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
              <BusRatesTable />

              <div id="why-choose-section" className="why-choose-section">


                {/* Section Title */}
                <h2 className="section-title">
                  Why Choose <span>Sanavi Travels </span>
                </h2>

                {/* Cards */}
                <div className="cards-grid">
                  {cardData.whychoose.map((item, index) => (
                    <div key={index} className="why-card">
                      <div className="icon-circle">{index + 1}</div>
                      <h4 className="card-heading">{item.WhyChooseheading}</h4>
                      <p className="card-desc">{item.WhyChoosedescription}</p>
                    </div>
                  ))}
                </div>
              </div>



              <div className="row twm-faq-section-1 m-b30">


                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                  <div className="twm-faq-info-wrap">

                    <div className="section-head left">
                      <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Sanavi Travels </h2>
                    </div>


                    <div className="twm-faq-info">
                      <div className="accordion twm-acdn" id="sf-faq-accordion">

                        <FaqSection
                          title="Frequently Asked"
                          subtitle="Help & Info"
                          items={faqData}
                        />

                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <TestimonialSectionKeyword
                testimonials={testimonials}
              />


              <ContactShowcase />
            </div>

            <div className='col-12 col-md-4' >
              <div className="routeList">
                {Images.map((e, i) => {
                  const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                  const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                  return (
                    <a
                      key={e.link || i}
                      href={href}
                      className="routeItem"
                      aria-label={e.text}
                      {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                    >
                      <div className="routeThumb">
                        <img src={e.place} alt="" loading="lazy" />
                      </div>

                      <div className="routeMeta">
                        <h6 className="routeTitle">{e.text}</h6>
                        <span className="routeUnderline" />
                      </div>

                      <span className="routeArrow" aria-hidden>›</span>
                    </a>
                  );
                })}
              </div>




              <div>
                <FleetHighway />
              </div>
              <div className="pc-contact">
                <h4 className="pc-title">Contact Information</h4>

                <div className="pc-grid">
                  {/* Phones */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-telephone-fill"></i>
                      <span>Phone Numbers</span>
                    </header>

                    <div className="pc-list">
                      <a href="tel:+917387507373" className="pc-call">+91 7387507373</a>
                      <a href="tel:+919595532929" className="pc-call">+91 9595532929</a>
                    </div>

                    <div className="pc-cta">
                      <a
                        href="https://wa.me/917387507373"
                        target="_blank" rel="noopener noreferrer"
                        className="pc-whats"
                      >
                        <i className="bi bi-whatsapp me-1"></i> WhatsApp
                      </a>
                      <a href="tel:+917387507373" className="pc-primary">
                        Call Now
                      </a>
                    </div>
                  </section>

                  {/* Email */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-envelope-fill"></i>
                      <span>Email</span>
                    </header>

                    <a href="mailto:booking@sanavitravels.com" className="pc-email">
                      booking@sanavitravels.com
                    </a>
                  </section>

                  {/* Address */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-house-fill"></i>
                      <span>Address</span>
                    </header>

                    <address className="pc-address">
                      <strong>Sanavi Travels</strong><br />
                      OFFICE NO.6, GROUND FLOOR GAT NO.1110,
                      SHREE GOPINATH MAHARAJ VYAPARI SHED SHIVAJI CHOWK, VARVAND TAL DAUND,
                      DIST PUNE – 412215
                    </address>
                  </section>
                </div>
              </div>


            </div>
          </div>
        </div>
      </section>


    </div>
  );
}

export default Ertigacabhireinpune;